module.exports = __webpack_public_path__ + "static/media/danskebank.060cb607.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/eidentify/components/Banks/danskebank.png
// module id = 2725
// module chunks = 0